import React, { useEffect, useState } from "react";
import style from "./intro.module.css";
import myimg from "../images/myimgf.png";
const Intro = () => {

  const [c, setc] = useState(0)
  useEffect(()=>{
    
      const id=setInterval(()=>{
        
          if(c<arr.length-1){
            setc(c+1)
            
          }else{
            setc(0)
          }
        
        
      },2000)
      return ()=>{clearInterval(id);
      }
  },[c])
  let arr=["Full Stack Web Developer","Problem Solver","Frontend Developer"]
  return (
    <div className={style.intro} id={style.top}>
      <img src={myimg} alt="img" className={style.myimg} />
      <div>
        <p className={style.ift}>Hello, My Name is</p>
        <h1 className={style.name}>Prakarsh Prasar</h1>
        
        
        <h2 className={c%2!==0?style.black:style.blue}>{arr[c]}</h2>
        <p className={style.inttext}>
          Enthusiastic engineering graduate with knowledge in coding and Web
          development. Proficient in <span>React JS</span>, <span>HTML</span>,{" "}
          <span>CSS</span>, <span>JavaScript</span>, <span>DSA</span>,{" "}
          <span>NodeJs</span>, <span>Express</span> and <span>MongoDB</span>.
          Ability to learn new software and technologies quickly. Capability to
          work in team by providing valuable support.
        </p>
      </div>

        
      
      
    </div>
  );
};

export default Intro;
